import { ProjectDependencyStackDepth } from '@models';

export interface ProjectDependencyStackDepthResult {
  projectsDependencyStackDepth: ProjectDependencyStackDepth[];
}
